import { createFileRoute } from '@tanstack/react-router';

import { SubscriptionDetailPage } from '@/pages/subscriptions/subscription-detail-page';

export const Route = createFileRoute('/subscriptions/$id')({
  component: SubscriptionDetail,
});

function SubscriptionDetail() {
  const { id } = Route.useParams();
  return <SubscriptionDetailPage id={id} />;
}
